export default __webpack_public_path__ + "static/media/booksmandala.0cb64c8a.png";